"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const shared_module_1 = require("../common/shared.module");
const angular_hybrid_1 = require("@uirouter/angular-hybrid");
const sso_config_states_1 = require("./sso-config.states");
const sso_config_component_1 = require("./ssoConfigFeature/sso-config.component");
const i0 = require("@angular/core");
const i1 = require("@uirouter/angular-hybrid");
class SsoConfigModule {
}
exports.SsoConfigModule = SsoConfigModule;
SsoConfigModule.ɵmod = i0.ɵɵdefineNgModule({ type: SsoConfigModule });
SsoConfigModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SsoConfigModule_Factory(t) { return new (t || SsoConfigModule)(); }, imports: [[
            shared_module_1.SharedModule,
            angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: sso_config_states_1.states })
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SsoConfigModule, { declarations: [sso_config_component_1.SsoConfigComponent], imports: [shared_module_1.SharedModule, i1.UIRouterUpgradeModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SsoConfigModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [
                    shared_module_1.SharedModule,
                    angular_hybrid_1.UIRouterUpgradeModule.forChild({ states: sso_config_states_1.states })
                ],
                declarations: [
                    sso_config_component_1.SsoConfigComponent
                ]
            }]
    }], null, null); })();
